export enum TableConstants {
  Empty = "N/A",
}
